var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoblin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m266.868 297.373c-12.496-12.497-32.758-12.497-45.254 0l-64 64c-6.002 6.001-9.373 14.141-9.373 22.627v64c-17.673 0-32 14.327-32 32 0 8.836 7.163 16 16 16h64c8.837 0 16-7.164 16-16v-82.745l54.627-54.627c12.497-12.497 12.497-32.759 0-45.255z",
    fill: "#82aa41"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m388.241 448c0-8.189-3.124-16.379-9.373-22.627l-54.627-54.627v-74.746c0-17.673-14.327-32-32-32s-32 14.327-32 32v88c0 8.487 3.371 16.626 9.373 22.627l41.373 41.373h-2.746c-17.673 0-32 14.327-32 32 0 8.836 7.163 16 16 16h80c8.837 0 16-7.164 16-16z",
    fill: "#a5cd3c"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m148.241 232c-4.418 0-8 3.582-8 8v8h-16c0-8.836-7.163-16-16-16v48h32v8c0 4.418 3.582 8 8 8h48v-64z",
    fill: "#82aa41"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m123.519 285.063c-9.22-4.219-15.278-13.256-15.278-23.395v-21.668c0-4.418 3.582-8 8-8s8-3.582 8-8-3.582-8-8-8h-32c-4.418 0-8 3.582-8 8s3.582 8 8 8 8 3.582 8 8v21.671c0 10.046-5.893 19.149-15.047 23.287-20.164 9.116-33.965 29.822-32.895 53.627 1.291 28.71 24.581 52.03 53.29 53.354 32.134 1.482 58.652-24.132 58.652-55.939 0-22.621-13.415-42.103-32.722-50.937z",
    fill: "#aa5a28"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m84.241 232c13.255 0 24 10.745 24 24 0 13.255-10.745 24-24 24-4.418 0-8-3.582-8-8v-32c0-4.418 3.582-8 8-8z",
    fill: "#a5cd3c"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m204.241 64c-26.51 0-48 21.49-48 48v48h8c26.51 0 48-21.49 48-48v-20c0-6.627 5.373-12 12-12 6.627 0 12-5.373 12-12v-4z",
    fill: "#82aa41"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m324.241 296h-128v26.745l-6.628 6.627c-12.497 12.497-12.497 32.758 0 45.255 12.497 12.497 32.758 12.497 45.255 0l32-32c4.196-4.196 6.976-9.269 8.354-14.627h49.018v-32z",
    fill: "#aa5a28"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m324.241 352v-56c0-17.436-13.67-32.175-31.1-32.653-18.084-.496-32.9 14.015-32.9 31.988v56.665c0 17.673 14.327 32 32 32 17.673 0 32-14.327 32-32z",
    fill: "#d76e28"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m236.241 208h-64c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h96c17.673 0 32 14.327 32 32v32c0 17.673-14.327 32-32 32 0 17.673-14.327 32-32 32z",
    fill: "#82aa41"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m212.241 160c-8.837 0-16 7.163-16 16v48c-19.648 0-35.619 15.74-35.993 35.298-.386 20.182 16.518 36.702 36.704 36.702h127.289v-136z",
    fill: "#4b8c41"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m284.241 64c-26.51 0-48 21.49-48 48 0-17.673-14.327-32-32-32h-32c-17.673 0-32 14.327-32 32-26.51 0-48 21.49-48 48h48v16c0 17.673 14.327 32 32 32h32c17.673 0 32-14.327 32-32v-16h8c26.51 0 48-21.49 48-48v-20c0-6.627 5.373-12 12-12s12-5.373 12-12v-4z",
    fill: "#a5cd3c"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m188.241 192h-16c-8.837 0-16-7.163-16-16h48c0 8.837-7.163 16-16 16z",
    fill: "#d7e6f0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m321.575 32v40c0 4.418 3.582 8 8 8h10.667v16h32v-64z",
    fill: "#82aa41"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m380.241 96h-48c-4.418 0-8 3.582-8 8v56c-17.673 0-32 14.327-32 32s14.327 32 32 32h32c17.673 0 32-14.327 32-32v-88c0-4.418-3.582-8-8-8z",
    fill: "#a5cd3c"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m308.241 64c4.418 0 8-3.582 8-8v-24c0-4.418-3.582-8-8-8-4.418 0-8 3.582-8 8v24c0 4.418 3.582 8 8 8z",
    fill: "#aac3d7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m316.241 32h64v24h-64z",
    fill: "#d76e28"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m321.575 72v-20c0-2.209 1.791-4 4-4 6.627 0 12 5.373 12 12v4c8.837 0 16 7.164 16 16h-24c-4.419 0-8-3.582-8-8z",
    fill: "#a5cd3c"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m329.575 24h34.667c4.418 0 8 3.582 8 8 0 4.418-3.582 8-8 8h-34.667c-4.418 0-8-3.582-8-8 0-4.418 3.581-8 8-8z",
    fill: "#a5cd3c"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m380.241 32 24-16 52.323 22.424c2.23.956 3.677 3.149 3.677 5.576 0 2.427-1.446 4.62-3.677 5.576l-52.323 22.424-24-16z",
    fill: "#aac3d7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoblin);
export default __webpack_public_path__ + "static/media/goblin.0cc724bf4afc84a9a3a440ca79bd69fa.svg";
export { ForwardRef as ReactComponent };